"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DVLItemSection = void 0;
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const useCallforward_1 = __importDefault(require("@opsbase/react-hooks/useCallforward"));
const useDataTree_1 = __importDefault(require("@opsbase/web-ctrl-datatree/useDataTree"));
const useNewDataActions_1 = __importDefault(require("@opsbase/web-ctrl-newdata/useNewDataActions"));
const useView_1 = __importDefault(require("@opsbase/web-ctrl-view/useView"));
const Dots_1 = __importDefault(require("@opsbase/web-ui/Dots"));
const debounce_1 = __importDefault(require("lodash/debounce"));
const react_1 = __importStar(require("react"));
const calcIsExpanded_1 = __importDefault(require("../helpers/calcIsExpanded"));
function DVLItemSection(props) {
    var _a, _b;
    const { nodeKey, component: Component } = props;
    const dt = (0, useDataTree_1.default)();
    const view = (0, useView_1.default)(dt.viewId);
    const node = dt.nodesByKey.get(nodeKey);
    const items = (0, react_1.useMemo)(() => { var _a; return ((_a = node.itemCollection) === null || _a === void 0 ? void 0 : _a.items) || []; }, [(_a = node.itemCollection) === null || _a === void 0 ? void 0 : _a.items]);
    const isLoading = node.itemCollection ? (_b = node.itemCollection) === null || _b === void 0 ? void 0 : _b.loading : true;
    const isExpanded = (0, calcIsExpanded_1.default)(view, node);
    const [focusedItem, setFocusedItem] = (0, react_1.useState)();
    const _doFocus = (0, debounce_1.default)(v => setFocusedItem(v), 100, { trailing: true, leading: false });
    const handleFocus = (0, useCallforward_1.default)(item => v => _doFocus(v ? item : undefined), [_doFocus]);
    const { getItemsForType } = (0, useNewDataActions_1.default)();
    const justAddedItems = getItemsForType(dt.viewId);
    return (0, react_1.useMemo)(() => {
        if (!isExpanded)
            return null;
        if (isLoading)
            return (react_1.default.createElement(Dots_1.default, { style: {
                    margin: '32px auto',
                }, color: lib_palette_1.default.LavendarGrey }));
        return (react_1.default.createElement(react_1.default.Fragment, null, items
            .filter(item => !justAddedItems.some(ji => ji.id === item.id))
            .map((item, rowIdx) => {
            const isLast = rowIdx === items.length - 1;
            return (react_1.default.createElement(Component, { key: 'item' + item.id, nodeKey: nodeKey, item: item, isLast: isLast, rowIdx: rowIdx, focused: item.id === (focusedItem === null || focusedItem === void 0 ? void 0 : focusedItem.id), onFocus: handleFocus(item) }));
        })));
    }, [
        Component,
        focusedItem === null || focusedItem === void 0 ? void 0 : focusedItem.id,
        handleFocus,
        isExpanded,
        isLoading,
        items,
        justAddedItems,
        nodeKey,
    ]);
}
exports.DVLItemSection = DVLItemSection;
exports.default = DVLItemSection;
